<template>
    <div class="w-auto h-auto p-2 flex flex-col justify-start items-center">
        <div
            class="w-full max-w-[800px] rounded-lg bg-slate-50 p-1 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] flex flex-wrap items-center justify-center">
            <div class="w-full text-2xl md:text-4xl font-semibold">{{ className + '班' }}</div>
            <div class="w-full py-1 md:py-3 px-3 flex flex-wrap items-center justify-center">
                <div class="w-auto text-[16px] md:text-2xl">選擇類型: </div>
                <div class="w-auto px-[1px] flex flex-wrap items-center justify-center">
                    <el-select v-model="Type" placeholder="Select" @change="changeType"
                        :style="{ 'width': isMobile ? '150px' : '400px' }">
                        <el-option v-for="item in formType" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
        <div v-for="(item, index) in list" :key="index" :class="(index % 2 == 0) ? 'bg-slate-50' : 'bg-slate-200'"
            @click="toShow(index)"
            class="w-[95%] md:w-[40%] h-[auto] text-sm md:text-lg rounded-lg bg-slate-50 my-1 px-1 py-2 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] flex flex-wrap items-center justify-end">
            <div class="w-[40px] h-[40px] md:w-[80px] md:h-[80px] bg-indigo-500 rounded-full">
                <img v-if="item.studentUserPictureUrl" :src="item.studentUserPictureUrl"
                    class="w-[40px] h-[40px] md:w-[80px] md:h-[80px] rounded-full" alt="">
            </div>
            <div class="w-auto px-1 h-full grow flex flex-col items-start justify-center">
                <div class="max-w-[50vw] md:max-w-[18vw] px-1 truncate">學生姓名：{{ item.studentUserName }}</div>
            </div>
            <template v-if="isshow === index">
                <div v-for="(data, dataIndex) in sortedForms(item.forms)" :key="dataIndex"
                    class="w-full my-2 text-left font-semibold pl-3">
                    <div>{{ getFormType(data.type) }}{{ data.name }}</div>
                    <div v-if="data.file && data.signFile"
                        class="w-full h-full my-2 flex flex-col justify-center items-center">
                        <img :src="data.file" alt="">
                        <img :src="data.signFile" alt="" class="mt-2">
                    </div>
                    <div v-else>
                        <span>檔案未上傳</span>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script setup>
/*eslint-disable*/
import { getFormRecord } from '@/api/api'
import { ref, computed, watch, provide } from "vue";
import { useStore } from "vuex";
import { baseURL } from '@/api'
import { useRouter, useRoute } from "vue-router";

const store = useStore()
const router = useRouter()
const route = useRoute()
const apiLoading = ref(false)
const list = ref([])
const Type = ref(0);
const formType = ref([
    { value: 0, label: '兒童發展檢核表' },
    { value: 1, label: '疫苗' },
])

const getFormType = (type) => {
    const found = formType.value.find(ft => ft.value === type)
    return found ? found.label : '未知類型'
}

const ageOrder = [
    '疫苗', '4個月', '6個月', '9個月', '1歲', '1歲3個月', '1歲半',
    '2歲', '2歲半', '3歲', '3歲半', '4歲', '5歲', '6歲'
]

const sortedForms = computed(() => (forms) => {
    return [...forms].sort((a, b) => {
        const indexA = ageOrder.indexOf(a.name)
        const indexB = ageOrder.indexOf(b.name)
        if (indexA === -1) return 1
        if (indexB === -1) return -1
        return indexA - indexB
    })
})

const isMobile = computed(() => {
    return store.state.isMobile
})

const classId = computed(() => {
    return localStorage.getItem('classId')
})

const className = computed(() => {
    return localStorage.getItem('className')
})

const modalStatus = ref(false)
const detail = (item) => {
    modalStatus = true;
};

const imgUrl = ref('')
const imgUrl1 = ref('')
const getList = async () => {
    const formData = new FormData()
    formData.append("classId", classId.value)
    formData.append("type", Type.value)
    await getFormRecord(formData).then((res) => {
        if (res.data.status) {
            const groupedList = groupByStudent(res.data.data)
            list.value = groupedList
        } else {
            console.log(res.data.message)
        }
    }).catch((err) => { })
}

const changeType = async (value) => {
    let name = ''
    for (let key in formType.value) {
        if (formType.value[key].value == value) {
            name = formType.value[key].value
            break
        }
    }
    Type.value = name;
    await getList()
}

const isshow = ref(null);
const toShow = (index) => {
    if (isshow.value === index) {
        isshow.value = null;
    } else {
        isshow.value = index;
    }
};

const groupByStudent = (data) => {
    const grouped = {}
    for (const record of data) {
        if (!grouped[record.studentId]) {
            grouped[record.studentId] = {
                studentId: record.studentId,
                studentUserName: record.studentUserName,
                studentUserPictureUrl: record.studentUserPictureUrl,
                studentSchoolStudentId: record.studentSchoolStudentId,
                forms: []
            }
        }
        grouped[record.studentId].forms.push({
            id: record.id,
            formId: record.formId,
            name: record.name,
            type: record.type,
            file: record.file? baseURL + record.file : record.file,
            signFile: record.signFile ? baseURL + record.signFile : record.signFile
        })
    }
    return Object.values(grouped).sort((a, b) =>
        a.studentSchoolStudentId.localeCompare(b.studentSchoolStudentId)
    )
}

const init = async () => {
    if (apiLoading.value) return false
    apiLoading.value = true
    getList()
    apiLoading.value = false
}

init()

</script>